import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.999863 0.947347C0.479863 1.46735 0.479863 2.30735 0.999863 2.82735L6.1732 8.00068L0.999863 13.174C0.479863 13.694 0.479863 14.534 0.999863 15.054C1.51986 15.574 2.35986 15.574 2.87986 15.054L8.99986 8.93401C9.51986 8.41401 9.51986 7.57401 8.99986 7.05401L2.87986 0.934014C2.3732 0.427347 1.51986 0.427347 0.999863 0.947347Z",
  fill: "#FF6D10"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "nk-popper-item-wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "flex gap-2 transition nk-popper-item group hover:text-primary"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.999863 0.947347C0.479863 1.46735 0.479863 2.30735 0.999863 2.82735L6.1732 8.00068L0.999863 13.174C0.479863 13.694 0.479863 14.534 0.999863 15.054C1.51986 15.574 2.35986 15.574 2.87986 15.054L8.99986 8.93401C9.51986 8.41401 9.51986 7.57401 8.99986 7.05401L2.87986 0.934014C2.3732 0.427347 1.51986 0.427347 0.999863 0.947347Z",
    fill: "#FF6D10"
  })
], -1)

import { computed } from 'vue';

import { NkBreadcrumbItem, NkGroup, NkButton, NkPopper, NkIcon, NkText } from '@/core/components';

import { props as propsDefinition } from './breadcrumb.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkBreadcrumb',
  props: propsDefinition,
  setup(__props) {

const props = __props



// eslint-disable-next-line no-unsafe-optional-chaining
const displayedIndex = computed(() => [0, props.links?.length - 1, props.links?.length - 2]);

const disaplyedLinks = computed(() => props.links?.filter((o, index) => displayedIndex.value.includes(index)) || []);
const undisplayedLinks = computed(() => props.links?.filter((o, index) => !displayedIndex.value.includes(index)) || []);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(NkGroup), {
    "no-wrap": "",
    spacing: 6,
    class: "nk-breadcrumb"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(disaplyedLinks), (link, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex items-center gap-x-5"
        }, [
          _createVNode(_unref(NkBreadcrumbItem), { link: link }, null, 8, ["link"]),
          (_unref(disaplyedLinks).length - 1 !== index)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
          (index === 0 && _unref(undisplayedLinks).length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_unref(NkPopper), { styled: "" }, {
                  reference: _withCtx(() => [
                    _createVNode(_unref(NkButton), {
                      type: "white",
                      size: "sm",
                      icon: "NkPendingPoint",
                      circle: ""
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(undisplayedLinks), (undisplayedLink, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `${_unref(undisplayedLinks)}-${i}`
                        }, [
                          (undisplayedLink.to)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: undisplayedLink.to,
                                class: "flex gap-2 transition nk-popper-item group hover:text-primary",
                                style: _normalizeStyle({ marginLeft: 0.5 * i + 'rem' })
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NkIcon), { name: "NkPictureInPicture" }),
                                  _createVNode(_unref(NkText), {
                                    class: "transition group-hover:text-primary",
                                    type: "bold",
                                    uppercase: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(undisplayedLink.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["to", "style"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createVNode(_unref(NkIcon), { name: "NkPictureInPicture" }),
                                _createVNode(_unref(NkText), {
                                  class: "transition group-hover:text-primary",
                                  type: "bold",
                                  uppercase: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(undisplayedLink.name), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _hoisted_6
              ], 64))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})